import SvgIcon, { SvgIconProps } from "./SvgIcon";

const HospitalityIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.82104 4.58189C3.29357 4.5244 3.72373 4.85816 3.78003 5.33092L4.62183 12.4256H7.17456C8.24224 12.4256 9.10815 13.2948 9.10815 14.3573V18.0907C9.10815 18.5626 8.72253 18.9538 8.24585 18.954C7.769 18.954 7.38257 18.5627 7.38257 18.0907V14.3573C7.38257 14.2492 7.28869 14.1512 7.17456 14.1512H4.57983L3.77026 18.2528C3.6836 18.6953 3.27805 18.9855 2.84351 18.9442L2.75659 18.9315C2.28819 18.8395 1.98445 18.3901 2.07593 17.9188L2.98804 13.2997L2.06616 5.53795C2.00988 5.06539 2.34856 4.63951 2.82104 4.58189Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M21.3384 4.58189C21.8115 4.63929 22.1511 5.06512 22.0942 5.53795L21.1704 13.2987L22.0835 17.9188C22.1756 18.3902 21.8717 18.8395 21.4038 18.9315C20.9373 19.0234 20.4825 18.7247 20.3901 18.2528L19.5796 14.1512H16.9849C16.871 14.1513 16.7778 14.249 16.7778 14.3573V18.0907C16.7778 18.5627 16.3909 18.954 15.9146 18.954C15.4379 18.9538 15.0522 18.5626 15.0522 18.0907V14.3573C15.0522 13.2949 15.9172 12.4257 16.9849 12.4256H19.5386L20.3794 5.33092C20.4357 4.85818 20.8659 4.52447 21.3384 4.58189Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M17.6233 8.051C18.0992 8.051 18.4864 8.43041 18.4866 8.9133C18.4866 9.38532 18.1002 9.77658 17.6233 9.77658H12.9612V18.091C12.961 18.5629 12.5749 18.9532 12.0989 18.9533C11.6221 18.9533 11.2358 18.5629 11.2356 18.091V9.77658H6.57153C6.09485 9.77639 5.70923 9.38521 5.70923 8.9133C5.70942 8.43053 6.09584 8.05119 6.57153 8.051H17.6233Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};

export default HospitalityIcon;
